<template>
  <v-container fluid class="main-invest-container">
    <v-flex xs12 py-0>
      <span @click="onBackLink()" class="goback">{{
        $t("pagesInvest.edit.goBack")
      }}</span>
    </v-flex>
    <loading :text="$t('pagesInvest.edit.loadData')" v-if="!isLoaded" />
    <v-layout row wrap text-center tender__not-found v-if="serverError">
      <v-flex xs12>
        <h1>{{ serverError }}</h1>
      </v-flex>
      <v-flex xs12 py-0>
        <v-divider />
      </v-flex>
    </v-layout>

    <div v-if="isLoaded && !serverError && offer">
      <v-layout row wrap>
        <v-flex xs12>
          <h1>{{ $t("pagesInvest.edit.title") }}: {{ offer.title }}</h1>
          <div class="subtitle1">{{ offer.name }}</div>
        </v-flex>
        <v-flex xs12 py-0 mb-5>
          <v-divider />
        </v-flex>
      </v-layout>
      <v-layout
        mb-3
        ml-0
        mr-2
        v-if="cIsEditValid"
        class="justify-space-between"
      >
        <v-btn
          color="deep orange"
          :disabled="offer.status == 30"
          class="white--text"
          x-large
          @click="onEditOffer()"
          >{{ $t("pagesInvest.edit.editBtn") }}</v-btn
        >
        <v-btn color="red" dark x-large @click="onDeleteOffer()">{{
          $t("pagesInvest.edit.deleteDraft")
        }}</v-btn>
      </v-layout>

      <v-container row wrap start>
        <invest-calc
          :offer="offer"
          wide
          v-on:invest::click="openInvestCreateModal"
        ></invest-calc>
      </v-container>

      <v-layout row wrap v-if="fakeBid">
        <v-flex xs12>
          <h1>{{ $t("pagesInvest.edit.chatTitle") }}</h1>
        </v-flex>
        <v-flex xs12 py-0 mb-5>
          <v-divider />
        </v-flex>
        <v-flex xs12>
          <div class="block">
            <bid-chat
              :read-only="offer.status == 40 || offer.status == 30"
              :bid="fakeBid"
            />
          </div>
        </v-flex>
      </v-layout>

      <v-layout row wrap mt-3 v-if="offer">
        <v-flex xs12 pt-0>
          <invest-info :offer="offer"></invest-info>
        </v-flex>
      </v-layout>

      <v-container row wrap start v-if="offer.status == 40">
        <v-layout row wrap>
          <v-flex xs12>
            <h3>{{ $t("pagesInvest.edit.offersTitle") }}</h3>
            <div class="subtitle1">
              {{ $t("pagesInvest.edit.offersDescr") }}
            </div>
          </v-flex>
          <v-flex xs12 py-0 mb-5>
            <v-divider />
          </v-flex>
          <v-flex xs12>
            <v-data-table
              :headers="headersOffers"
              :items="offer.userOffers"
              :items-per-page="100"
              hide-default-footer
              class="elevation-1"
            >
              <template v-slot:item="{ item }">
                <tr @click="onClickInvestUsers(item.id)">
                  <td class="text-center">
                    {{ item.created_at | formatDate }}
                  </td>
                  <td class="text-center">
                    <span v-if="item.clientCompany">{{
                      item.clientCompany.organization_short_name
                    }}</span>
                    <span v-if="item.clientPhysical">{{
                      item.clientPhysical.full_name
                    }}</span>
                  </td>
                  <td class="text-center">{{ item.price | formatPrice }}</td>
                  <td class="text-center">
                    {{ item.month }} {{ $t("pagesInvest.edit.monthShort") }}
                  </td>
                  <td class="text-center">{{ item.percent }}%</td>
                  <td class="text-center">
                    {{
                      item.payout_type == 1
                        ? $t("utilsData.statuses.split.payoutTypeList.1")
                        : $t("utilsData.statuses.split.payoutTypeList.4")
                    }}
                  </td>
                  <td class="text-center">
                    {{ item.profit | formatPrice }}
                    <div class="subtitle1">
                      {{ item.profit_each_month | formatPrice }}/
                      {{ $t("pagesInvest.edit.monthShort") }}
                    </div>
                  </td>
                  <td class="text-center">
                    <v-chip
                      :color="getStatusUserColor(item.status)"
                      :text-color="getStatusUserTextColor(item.status)"
                      >{{ getStatusUserName(item.status) }}</v-chip
                    >
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <v-dialog v-model="createInvestModal" max-width="600px" persistent>
      <v-layout row wrap modal__block>
        <span class="modal__close" @click="closeInvestCreateModal"></span>
        <v-flex
          xs12
          modal__wrapper
          v-if="createInvestModal"
          style="min-height: 400px"
        >
          <v-card-title class="headline">{{
            $t("pagesInvest.edit.investModalTitle")
          }}</v-card-title>
          <v-tabs
            v-model="tabInvestAddTypFace"
            background-color="transparent"
            ddark
            color="blue"
            grow
          >
            <v-tab v-for="tabItem in addInvestTabItems" :key="tabItem.id">
              {{ tabItem.name }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tabInvestAddTypFace">
            <v-tab-item v-for="tabItem in addInvestTabItems" :key="tabItem.id">
              <v-card class="mb-3">
                <v-card-text v-if="tabItem.id == 1">
                  <company-search
                    :onChangeCallback="onChangeCallbackCompanySearch"
                  ></company-search>
                </v-card-text>
                <v-card-text v-if="tabItem.id == 2">
                  <physical-search
                    :onChangeCallback="onChangeCallbackPhysicalSearch"
                  ></physical-search>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>

          <v-card>
            <v-card-text>
              <invest-calc :offer="offer" v-if="offer"></invest-calc>
            </v-card-text>
          </v-card>

          <v-btn
            class="mt-5"
            :loading="createInvestLoading"
            @click="addNewInvest"
            :disabled="!cHasCompany"
            x-large
            style="color: white"
            color="green"
            >{{ $t("pagesInvest.edit.addNewInvest") }}</v-btn
          >
        </v-flex>
      </v-layout>
    </v-dialog>

    <v-dialog v-model="confirmDeleteDialog" persistent max-width="300">
      <v-card>
        <v-card-title class="headline" style="word-break: normal">
          {{ $t("pagesInvest.edit.deleteOfferTitle") }}
        </v-card-title>
        <v-card-text>
          {{ $t("pagesInvest.edit.deleteOfferDescription") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            outlined
            text
            :loading="isDeleteLoader"
            :disabled="isDeleteLoader"
            @click="confirmDeleteDialog = false"
          >
            {{ $t("pagesInvest.edit.deleteOfferCancel") }}
          </v-btn>
          <v-btn
            color="red darken-1"
            :loading="isDeleteLoader"
            :disabled="isDeleteLoader"
            @click="onDeleteAjax"
          >
            {{ $t("pagesInvest.edit.deleteOfferDelete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { apiCallTrue } from "@/utils/api";
import formatPrice from "@/mixins/filters/formatPrice";
//import formatNumber from "@/mixins/filters/formatNumber";
import formatDate from "@/mixins/filters/formatDate";
//import { mask } from "vue-the-mask";
import showNotify from "@/services/noty";
import investCalc from "@/components/invest/calc";
import statusNames from "@/utils/data/statuses";
import CompanySearch from "@/components/lib/CompanySearch";
import PhysicalSearch from "@/components/lib/PhysicalSearch";
import InvestInfo from "@/components/invest/Info";
import BidChat from "@/components/bids/chat";
import i18n from "@/services/i18n";

export default {
  name: "EditInvest",
  //directives: { mask },
  mixins: [formatPrice, formatDate],
  data: () => ({
    isLoaded: false,
    offer: null,
    serverError: null,
    myHTML: null,
    tab: 0,
    tabs: [
      { id: "info", name: i18n.t("pagesInvest.edit.tabs.info"), editMode: false, loading: false },
      { id: "buisnes", name: i18n.t("pagesInvest.edit.tabs.buisnes"), editMode: false, loading: false },
      { id: "documents", name: i18n.t("pagesInvest.edit.tabs.documents"), editMode: false, loading: false },
      { id: "finance", name: i18n.t("pagesInvest.edit.tabs.finance"), editMode: false, loading: false },
    ],

    headersOffers: [
      {
        text: i18n.t('"pagesInvest.edit.table.fields.created_at'),
        align: "center",
        sortable: false,
        value: "created_at",
      },
      { text: i18n.t('pagesInvest.edit.table.fields.clientCompany'), value: "clientCompany", align: "center" },
      { text: i18n.t('pagesInvest.edit.table.fields.price'), value: "price", align: "center" },
      { text: i18n.t('pagesInvest.edit.table.fields.month'), value: "month", align: "center" },
      { text: i18n.t('pagesInvest.edit.table.fields.percent'), value: "percent", align: "center" },
      { text: i18n.t('pagesInvest.edit.table.fields.payout_type'), value: "payout_type", align: "center" },
      { text: i18n.t('pagesInvest.edit.table.fields.profit'), value: "profit", align: "center" },
      { text: i18n.t('pagesInvest.edit.table.fields.status'), value: "status", align: "center" },
    ],
    statusNames,
    createInvestModal: false,
    createInvestCompany: null,
    createInvestPhysical: null,
    createInvestLoading: false,

    confirmDeleteDialog: false,
    isDeleteLoader: false,

    tabInvestAddTypFace: null,
    addInvestTabItems: [
      { id: 1, name: i18n.t('pagesInvest.edit.addInvestTabItems.1') },
      { id: 2, name: i18n.t('pagesInvest.edit.addInvestTabItems.2') },
    ],

    physical: {
      model: null,
      items: [],
      loading: false,
      search: null,
    },
  }),
  components: {
    investCalc,
    CompanySearch,
    PhysicalSearch,
    BidChat,
    InvestInfo,
  },

  computed: {
    ...mapState({
      userId: (state) => state.user.profile.id,
    }),

    fakeBid() {
      if (this.offer) {
        if (this.offer.status == 0 && !this.offer.package.lastHistory)
          return null;
        if (this.offer.status == 40) return null;
        if (this.offer.user_created != this.userId) return null;
        let tmpBid = Object.assign({}, this.offer);
        tmpBid.status = 60;
        return tmpBid;
      }
      return null;
    },

    cInvestAbout() {
      if (this.offer && this.offer.package && this.offer.package.investAbout) {
        if (this.offer.package.investAbout.data)
          return this.offer.package.investAbout.data.text;
      }
      return null;
    },

    cIsEditValid() {
      if (
        this.offer &&
        this.userId &&
        this.offer.package &&
        this.offer.package.user_id == this.userId
      ) {
        if (this.offer.status == 0 || this.offer.status == 30) return true;
      }

      return false;
    },

    isReadOnlyDocuments() {
      //return false;
      return true;
      // if(this.offer && this.userId && this.userId != this.offer.user_created)
      //   return false;
      // return true;
    },
    cIsPhysical() {
      if (this.tabInvestAddTypFace == 1) return true;
      return false;
    },
    cHasCompany() {
      if (this.cIsPhysical) return this.createInvestPhysical;
      return this.createInvestCompany;
    },
  },

  methods: {
    onClickInvestUsers(investUserId) {
      if (this.userId == this.offer.user_created) {
        this.$router.push({
          name: "InvestDealShow",
          params: { id: investUserId },
        });
      }
    },
    getSrcImageFile(fileId) {
      return `${window.$api_url}v1/files/${fileId}/show-image`;
    },

    async onDeleteAjax() {
      this.isDeleteLoader = true;
      await apiCallTrue({
        url: `v1/invest/offers/${this.offer.id}/draft/delete`,
      })
        .then(() => {
          this.onBackLink();
        })
        .catch((error) => {
          showNotify("error", error);
        })
        .finally(() => {
          this.isDeleteLoader = false;
        });
    },

    onDeleteOffer() {
      this.confirmDeleteDialog = true;
    },

    onEditOffer() {
      this.$router.push({ name: "InvestAddEdit", id: this.offer.id });
    },
    getChecklistIcon(status) {
      let output = null;

      switch (status) {
        case 0:
          output = "block";
          break;
        case 1:
          output = "check";
          break;
        case 2:
          output = "watch_later";
          break;
      }
      return output;
    },
    getChecklistStatus(status) {
      let output = null;

      switch (status) {
        case 0:
          output = "error";
          break;
        case 1:
          output = "success";
          break;
        case 2:
          output = "warning";
          break;
      }
      return output;
    },

    __findTabById(name) {
      for (let p in this.tabs) {
        if (this.tabs[p].id == name) return this.tabs[p];
      }
      return null;
    },
    updateCustomPackageDocuments(uploadedDocument) {
      if (!this.offer.package.documents.data[1].folders)
        this.offer.package.documents.data[1].folders = [];
      this.offer.package.documents.data[1].folders.push(uploadedDocument);
      let tab = this.__findTabById("documents");
      if (tab) this.saveTabInvest(tab, false);
    },
    updatePackageDocuments(uploadedDocument) {
      this.offer.package.documents.data.forEach((folder) => {
        if (folder.folders) {
          folder.folders.forEach((file) => {
            if (file.id === uploadedDocument.folder_id) {
              file.document = {};
              Object.assign(file.document, uploadedDocument);
            }
          });
        }
      });

      let tab = this.__findTabById("documents");
      if (tab) this.saveTabInvest(tab, false);
    },
    updateDocuments() {
      this.getOffer(this.offer.id);
    },
    async saveTabInvest(tab, showLoading = true) {
      tab.loading = true;
      let data = {
        type: 20,
        data: this.offer.package.investAbout.data,
      };
      let typeStr = "investAbout";
      if (tab.id == "buisnes") {
        data.type = 21;
        typeStr = "investBusiness";
        data.data = this.offer.package.investBusiness.data;
      }
      if (tab.id == "documents") {
        data.type = 1;
        typeStr = "documents";
        data.data = this.offer.package.documents.data;
      }
      await apiCallTrue({
        url: `v1/package/${this.offer.package.id}/items/${typeStr}`,
        method: "POST",
        data,
      })
        .then((resp) => {
          this.toggleEditModeTab(tab);
          console.log("resp", resp);
          this.getOffer(this.offer.id, null, null, null, showLoading);
        })
        .catch((error) => {
          showNotify("error", error);
          this.serverError = error.message;
        })
        .finally(() => {
          tab.loading = false;
        });
    },
    toggleEditModeTab(tab) {
      tab.editMode = tab.editMode ? false : true;
      if (tab.id == "info") {
        if (tab.editMode) {
          if (!this.offer.package.investAbout) {
            this.offer.package.investAbout = {
              data: { text: "", images: null },
            };
          }
          this.offer.package.investAbout.dataCopy = new String(
            this.offer.package.investAbout.data.text
          ).toString();
        } else {
          if (this.offer.package.investAbout.dataCopy)
            this.offer.package.investAbout.data.text = this.offer.package.investAbout.dataCopy;
          delete this.offer.package.investAbout["dataCopy"];
        }
      }

      if (tab.id == "buisnes") {
        if (tab.editMode) {
          if (!this.offer.package.investBusiness) {
            this.offer.package.investBusiness = {
              data: { text: "", images: null },
            };
          }
          this.offer.package.investBusiness.dataCopy = new String(
            this.offer.package.investBusiness.data.text
          ).toString();
        } else {
          if (this.offer.package.investBusiness.dataCopy)
            this.offer.package.investBusiness.data.text = this.offer.package.investBusiness.dataCopy;
          delete this.offer.package.investBusiness["dataCopy"];
        }
      }
    },
    addNewInvest() {
      if (!this.cHasCompany) return;
      const url = `v1/invest/offers/${this.offer.id}/create`;
      let data = Object.assign({}, this.offer.realCalc);
      data.payout_type = data.mode ? 1 : 0;
      data.inn = this.cHasCompany.inn;
      data.physical_id = this.cHasCompany.id;
      data.is_physical = this.cIsPhysical;

      this.createInvestLoading = true;
      apiCallTrue({ url, data, method: "POST" })
        .then(() => {
          this.closeInvestCreateModal();
          this.getOffer(this.offer.id);
        })
        .catch((error) => {
          showNotify("error", error);
        })
        .finally(() => {
          this.createInvestLoading = false;
        });
    },
    onChangeCallbackCompanySearch(obj) {
      this.createInvestCompany = obj;
      // console.log("OOO", obj);
    },
    onChangeCallbackPhysicalSearch(obj) {
      this.createInvestPhysical = obj;
      // console.log("PHYS", obj);
    },
    closeInvestCreateModal() {
      this.createInvestModal = false;
    },
    openInvestCreateModal() {
      this.createInvestModal = true;
    },
    getStatusUserName(id) {
      if (!id) return;
      if (!this.statusNames) return;
      return this.statusNames.investUserDefault[id].name
        ? this.statusNames.investUserDefault[id].name
        : "";
    },
    getStatusUserColor(id) {
      if (!id) return;
      if (!this.statusNames) return;
      return this.statusNames.investUserDefault[id].color
        ? this.statusNames.investUserDefault[id].color
        : "";
    },
    getStatusUserTextColor(id) {
      if (!id) return;
      if (!this.statusNames) return;
      return this.statusNames.investUserDefault[id].textColor
        ? this.statusNames.investUserDefault[id].textColor
        : "";
    },
    onBackLink() {
      this.$router.push({ name: "Invest" });
    },
    async getOffer(id, mode, price, month, showLoading = true) {
      const url = `v1/invest/offers/${id}`;
      this.isLoaded = showLoading ? false : true;
      this.serverError = null;

      await apiCallTrue({ url })
        .then((response) => {
          this.offer = response.data.data;
          if (mode || price || month) {
            this.offer.realCalc = {};
            if (mode) {
              this.offer.realCalc.mode = mode;
            }
            if (price) {
              this.offer.realCalc.price = price;
            }
            if (month) {
              this.offer.realCalc.month = month;
            }
          }
        })
        .catch((error) => {
          console.log("ERROR", error);
          showNotify("error", error);
          this.serverError = error.message;
        })
        .finally(() => {
          this.isLoaded = true;
        });
    },
  },
  mounted() {
    // Vue.use(wysiwyg, {});
    const { id, mode, price, month } = this.$route.params;
    this.getOffer(id, mode, price, month);
  },
};
</script>

<style lang="scss" scoped>
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
.main-invest-container {
  .v-list.danse__list_item {
    > .v-list-item {
      min-height: 30px;
    }
  }
}
.about-main,
.buisnes-main {
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-top: 20px;
}
.about-main > div:first-child,
.buisnes-main > div:first-child {
  flex-grow: 1;
  padding-right: 10px;
}

.about-main > div:last-child,
.buisnes-main > div:last-child {
  min-width: 364px;
}
.fly-panel {
  top: 0;
  position: sticky;
}
table.table-buisnes-options {
  width: 100%;
  border-collapse: collapse;
}

table.table-buisnes-options tr {
  border-top: 1px solid #d8d8d8;
}

table.table-buisnes-options tr:nth-child(2n-2) {
  background-color: #fbfbfb;
}

.finance-layout > div {
  width: 50%;
}

.finance-layout table > tbody > tr > td:first-child {
  min-width: 185px;
}

.main-info-wrap {
  columns: 2;
  > .main-info-item {
    opacity: 1;
  }
  // padding: 16px;
  // text-align: left;
  // display: flex;
  // flex-wrap: wrap;
  // h2 {
  //   min-width: 100%;
  //   width: 100%;
  // }

  // &--compact {
  //   background: #fff;
  //   padding: 16px;
  //   border-radius: 5px;
  //   box-shadow: 0 0 10px #aaa;

  //   .main-info-item {
  //     max-width: 100%;
  //     flex-basis: 100%;
  //   }
  //   .main-info-wrap {
  //     padding-top: 8px;
  //   }
  // }

  // .v-divider {
  //   margin: 8px 0;
  // }

  // &-wrap {
  //   display: flex;
  //   flex-wrap: wrap;
  //   padding-top: 24px;
  // }

  // &-item {
  //   max-width: 49%;
  //   min-width: 49%;

  //   &:nth-child(2n + 2) {
  //     margin-left: 2%;
  //   }
  // }
}

@media screen and (max-width: 1200px) {
  .finance-layout {
    flex-wrap: wrap;
  }
  .finance-layout > div {
    width: 100%;
  }
}
</style>
